import { ContextVM } from '../api';

export type ContextState = ContextVM;

export interface DonneesPartenaire {
  idClientPartenaire: string;
  idInteractionOrigine: string;
}

export interface Souscripteur {
  civilite: number;
  prenom: string;
  nom: string;
  dateNaissance: string;
  paysNaissance: string;
  departementNaissance: string;
  villeNaissance: string;
  adresse: string;
  codePostal: string;
  ville: string;
  email: string;
  typologieSouscripteur: string;
}

export const initialContextState: ContextState = {
  token: '',
  codeOperation: null,
  modeConnexion: null,
  referenceDevis: null,
  branche: null,
  produit: null,
  canalVente: null,
  originalCanalVente: null,
  typeContact: null,
  referenceContrat: null,
  codeVendeur: null,
  avenants: null,
  donneesPartenaire: undefined,
  souscripteur: undefined,
  partnerCode: undefined,
  declaration: null,
};
